<template>
  <div class="component-content">
    <div class="ball-loading" v-if="loading">
      <div class="k-ball-holder3">
        <div class="k-ball7a"></div>
        <div class="k-ball7b"></div>
        <div class="k-ball7c"></div>
        <div class="k-ball7d"></div>
      </div>
    </div>
    <div class="card-room" v-else>
      <div class="no-list" v-if="!conference.name">
        <p>会议错误，请联系系统管理员</p>
      </div>
      <div class="card-item no-border">
        <div class="title">
          <div class="r">{{conference.status}}</div>
          <h3 class="name">{{conference.name}}</h3>
        </div>
        <div class="info">
          <p>会议时间：{{conference.conferenceTime}}</p>
          <p>会议地点：{{conference.depName+' - '+conference.address}}</p>
          <p>会议要求：{{conference.req?conference.req:'无'}}</p>
        </div>
        <h3 class="meeting-user-title">会议人员确认情况</h3>
        <el-table :data="meetingUsers">
          <el-table-column label="参会人员">
            <template slot-scope="scope">
              {{ scope.row.user.name +" - "+ (scope.row.user.telephone?scope.row.user.telephone:scope.row.user.mobile)
              }}
            </template>
          </el-table-column>
          <el-table-column label="是否确认参会" align="right">
            <template slot-scope="scope">
              <span class="success" v-if="scope.row.isJoin">已确认参会</span>
              <span class="error" v-else>未确认</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  export default {
    components: {
      UserInfo,
    },
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        loading: true,
        meetingId: '',
        conference: {},
        meetingUsers: [],
      }
    },
    mounted() {
      this.meetingId = this.$route.params.mid
      this.getMeetingUsers()
    },
    methods: {
      // 获取参会人员列表
      getMeetingUsers() {
        ajax.post('/conference/users/stuats/List', {
          conferenceId: this.meetingId
        }, (res) => {
          this.loading = false
          this.conference = res.vo.array[0].conference
          this.meetingUsers = res.vo.array
        })
      },
    },
    watch: {

    }
  };
</script>


// WEBPACK FOOTER //
// src/page/m/meetingusers.vue